module.exports = __webpack_public_path__ + "img/desktop-pressure.f8817324.png";